import { render, staticRenderFns } from "./BannerCovid.vue?vue&type=template&id=6055932a"
import script from "./BannerCovid.vue?vue&type=script&lang=js"
export * from "./BannerCovid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports